const reportConstants = {
  DEFAULT_SCALE_LEVELS: [
    { value: 2, unit: "hour" },
    { value: 1, unit: "hour" },
    { value: 30, unit: "minute" },
    { value: 10, unit: "minute" },
  ],
  REPORT_STOP_TYPES: {
    delivery: "delivery",
    pickup: "pickup",
    deliveryReturn: "deliveryReturn",
    delay: "delay",
    clockInStop: "clockInStop",
    clockOutStop: "clockOutStop",
    gateInStop: "gateInStop",
    gateOutStop: "gateOutStop",
    trailerHook: "trailerHook",
    trailerDrop: "trailerDrop",
    delayedStop: "delayedStop",
    dispatchTimeStop: "dispatchTimeStop",
    restBreak: "restBreak",
    dispatchCancelStop: "dispatchCancelStop",
    terminalExitStop: "terminalExitStop",
    terminalEntryStop: "terminalEntryStop",
  },
  REPORT_STOP_TYPE_LABEL: {
    delay: "DY",
    delivery: "DL",
    pickup: "PU",
    deliveryReturn: "DL - RTN",
    clockInStop: "clk in",
    clockOutStop: "clk out",
    gateInStop: "gate In",
    gateOutStop: "gate Out",
    trailerHook: "TH",
    trailerDrop: "TD",
    deliveryException: "DL - ADE",
    lunchBreak: "LB",
    fuelBreak: "FB",
    pickupNF: "PU - NF",
    dispatchTimeStop: "Dispatch Time",
    restBreak:"RB",
    dispatchCancelStop: "Dispatch Canceled",
    terminalExitStop: "Geofence Exit",
    terminalEntryStop: "Geofence Entry"
  },
  DISPATCH_STOP_TYPES: {
    DELIVERY: "Delivery",
    PICKUP: "Pickup",
    FUELBREAK: "FuelBreak",
    LUNCHBREAK: "LunchBreak",
    TRAILERHOOK: "TrailerHook",
    TRAILERDROP: "TrailerDrop",
    RESTBREAK: "RestBreak"
  },
  APP_DATE_FORMAT: "yyyy-MM-dd",
  REPORT_DISPLAY_DATE_FORMAT : "MM/dd/yy",
  DISPATCH_STOP_STATUS_TYPES: {
    DELAYED: "Delayed",
    ONTIME: "On Time",
    PICKUP_NO_FREIGHT: "No Freight",
  },
  REPORT_TYPES: {
    TERMINAL: "terminal",
    DRIVER: "driver",
  },
  SEARCH_BY_OPTIONS: [
    { label: "Driver", value: "driver" },
    { label: "Terminal", value: "terminal" },
  ],
  PRINT_ACTIVITY_TYPES : {
    LunchBreak : "Lunch Break",
    FuelBreak : "Fuel Break",
    Delivery : "D",
    Pickup : "P",
    TrailerHook : "Trailer Hook",
    TrailerDrop : "Trailer Drop",
    RestBreak : "Rest Break"
  }
};

export default reportConstants;
